// dot_show: false,
// number_show: false,

export const scoreConfig_AllergyandEczema_bwccore = [
    {
        titel: `Asthma`,
        match_key: 'Asthma',
        Xdotpos: 177,
        Ydotpos: 715,
        Xnumberpos: 580,
        Ynumberpos: 690,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 4,
        dot_show: false,
        number_show: false,
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzii',
            // 'Candida albican',
            'Bifidobacterium bifidum',
            // 'Bifidobacterium breve',
            'Lactobacillus plantarum',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Constipation`,
        match_key: 'Constipation',
        Xdotpos: 177,
        Ydotpos: 568,
        Xnumberpos: 580,
        Ynumberpos: 541,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 4,
        dot_show: false,
        number_show: false,
        value_use: [
            'Faecalibacterium prausnitzii',
            // 'Staphylococcus aureus',
            // 'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            // 'Lactobacillus paracasei',
            'Lactobacillus plantarum',
            'Lactobacillus rhamnosus'
        ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Food allergy`,
        match_key: 'Food allergy',
        Xdotpos: 177,
        Ydotpos: 816,
        Xnumberpos: 580,
        Ynumberpos: 790,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 4,
        dot_show: false,
        number_show: false,
        value_use: [
            // 'Bacteroidetes phylum',
            'Bacteroides fragilis',
            'Bifidobacterium bifidum',
            // 'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus plantarum',
            // 'Streptococcus thermophilus'

        ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Immune`,
        match_key: 'Immunity',
        Xdotpos: 177,
        Ydotpos: 777,
        Xnumberpos: 580,
        Ynumberpos: 750,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 4,
        dot_show: false,
        number_show: false,
        value_use: [
            'Alistipes putredinis',
            'Roseburia hominis',
            // 'Bifidobacterium breve',
            'Bifidobacterium longum',
            // 'Lactobacillus helveticus',
            // 'Lactobacillus paracasei',
            // 'Streptococcus thermophilus'
        ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: `Inflammation`,
        match_key: 'Inflammation',
        Xdotpos: 177,
        Ydotpos: 777,
        Xnumberpos: 580,
        Ynumberpos: 750,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 4,
        dot_show: false,
        number_show: false,
        value_use: [
            'Alistipes putredinis',
            'Roseburia hominis',
            // 'Bifidobacterium breve',
            'Bifidobacterium longum',
            // 'Lactobacillus helveticus',
            // 'Lactobacillus paracasei',
            // 'Streptococcus thermophilus'
        ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
]

// Export bacteria type configuration for BWC Core format
export const typeofbacteria_bwccore = {
  core_bacteria: [
    'Akkermansia muciniphila',
    'Alistipes putredinis',
    'Bacteroidetes phylum',
    'Bacteroides fragilis',
    'Clostridium cluster IV',
    'Enterococcus genus',
    'Faecalibacterium prausnitzii',
    'Roseburia hominis',
    'Ruminococcus genus'
  ],
  harmful_bacteria: [
    'Bacillus genus',
    'Candida albicans',
    'Clostridium difficile',
    'Escherichia coli',
    'Staphylococcus aureus'
  ],
  beneficial_bacteria: [
    'Bifidobacterium bifidum',
    'Bifidobacterium breve',
    'Bifidobacterium lactis',
    'Bifidobacterium longum',
    'Lactobacillus acidophilus',
    'Lactobacillus gasseri',
    'Lactobacillus helveticus',
    'Lactobacillus paracasei',
    'Lactobacillus plantarum',
    'Lactobacillus reuteri',
    'Lactobacillus rhamnosus',
    'Streptococcus thermophilus'
  ]
};
